import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from '@mui/material'
import * as React from 'react'
import AuthComponent from './AuthComponent'
import CloseIcon from '@mui/icons-material/Close'

interface IAuthDialogComponentProps {
  openAuthDialog: boolean
  school_details: any
  closeAuthDialogFunction: (isCancel?: boolean) => void
}
interface IAuthDialogComponentState {
  isMobile: boolean
  onClient: boolean
}

export class AuthDialogComponent extends React.Component<
  IAuthDialogComponentProps,
  IAuthDialogComponentState
> {
  constructor(props: IAuthDialogComponentProps) {
    super(props)

    this.state = {
      isMobile: false,
      onClient: false,
    }
  }

  componentDidMount() {
    this.setState({
      isMobile: innerWidth < 400,
      onClient: true,
    })
  }

  render() {
    return (
      <div>
        <Dialog
          onClose={() => {
            this.props.closeAuthDialogFunction(false)
          }}
          // fullScreen={this.state.isMobile}
          fullScreen={true}
          open={this.props.openAuthDialog}
        >
          <DialogTitle style={{ padding: '0px', zIndex: 10 }}>
            <IconButton
              color="inherit"
              onClick={() => {
                this.props.closeAuthDialogFunction(true)
              }}
              aria-label="Close"
              style={{
                position: 'absolute',
                top: '10px',
                zIndex: 10,
                right: '20px',
              }}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          {/* <Divider /> */}
          <DialogContent style={{ padding: '0px' }}>
            <AuthComponent
              onSuccess={() => {
                this.props.closeAuthDialogFunction()
              }}
              isDialog={true}
              school_details={this.props.school_details}
            />
          </DialogContent>
          <Divider />
        </Dialog>
      </div>
    )
  }
}
